module.exports = __webpack_public_path__ + "img/artboard2.4f045f2d.webp";